/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/balance.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../google/api/annotations_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')

var utilspb_pagination_pb = require('../utilspb/pagination_pb.js')
const proto = {};
proto.reportpb = require('./balance_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.BalanceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.BalanceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListBalanceRequest,
 *   !proto.reportpb.ListBalanceResponse>}
 */
const methodDescriptor_BalanceService_ListBalance = new grpc.web.MethodDescriptor(
  '/reportpb.BalanceService/ListBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListBalanceRequest,
  proto.reportpb.ListBalanceResponse,
  /**
   * @param {!proto.reportpb.ListBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.BalanceServiceClient.prototype.listBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.BalanceService/ListBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.BalanceServicePromiseClient.prototype.listBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.BalanceService/ListBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListBalance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListBalanceDateRangeRequest,
 *   !proto.reportpb.ListBalanceResponse>}
 */
const methodDescriptor_BalanceService_ListBalanceDateRange = new grpc.web.MethodDescriptor(
  '/reportpb.BalanceService/ListBalanceDateRange',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListBalanceDateRangeRequest,
  proto.reportpb.ListBalanceResponse,
  /**
   * @param {!proto.reportpb.ListBalanceDateRangeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListBalanceDateRangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.BalanceServiceClient.prototype.listBalanceDateRange =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.BalanceService/ListBalanceDateRange',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListBalanceDateRange,
      callback);
};


/**
 * @param {!proto.reportpb.ListBalanceDateRangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.BalanceServicePromiseClient.prototype.listBalanceDateRange =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.BalanceService/ListBalanceDateRange',
      request,
      metadata || {},
      methodDescriptor_BalanceService_ListBalanceDateRange);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.StreamBalanceRequest,
 *   !proto.reportpb.Balance>}
 */
const methodDescriptor_BalanceService_StreamBalance = new grpc.web.MethodDescriptor(
  '/reportpb.BalanceService/StreamBalance',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.reportpb.StreamBalanceRequest,
  proto.reportpb.Balance,
  /**
   * @param {!proto.reportpb.StreamBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.Balance.deserializeBinary
);


/**
 * @param {!proto.reportpb.StreamBalanceRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.Balance>}
 *     The XHR Node Readable Stream
 */
proto.reportpb.BalanceServiceClient.prototype.streamBalance =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/reportpb.BalanceService/StreamBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_StreamBalance);
};


/**
 * @param {!proto.reportpb.StreamBalanceRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.Balance>}
 *     The XHR Node Readable Stream
 */
proto.reportpb.BalanceServicePromiseClient.prototype.streamBalance =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/reportpb.BalanceService/StreamBalance',
      request,
      metadata || {},
      methodDescriptor_BalanceService_StreamBalance);
};


module.exports = proto.reportpb;

